import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { BadgeSvg } from './svg/badge';

export const BadgeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BadgeSvg} {...props} />
);
